export const GLOBAL_DOWNLOADS_CONTEXT = 'global-downloads';

export const GLOBAL_DOWNLOADS_GOOGLE_ANALYTICS_TAG = 'GlobalDownload';

export const GLOBAL_DOWNLOADS_REPORT_TYPES = {
  GLOBAL_DOWNLOAD: 'global_download',
};
